export default __webpack_public_path__ + "static/media/moderate.94d31b9d.svg";